import React from "react";

import { useNavigate } from "react-router-dom";

import useHttpManagedBase from "commons/hooks/useHttpManagedBase";

export const baseUrl: string = "/backoffice/api/public";

function useHttpManagedNotAuthenticated() {
    const navigate = useNavigate();

    const getAccessToken: () => undefined = React.useCallback(() => undefined, []);

    return useHttpManagedBase({
        baseUrl: baseUrl,
        uiBaseUrl: "" + process.env.PUBLIC_URL,
        accessTokenGetter: getAccessToken,
        navigate: navigate,
    });
}

export default useHttpManagedNotAuthenticated;
